import { get } from 'lodash';

import { RootState } from '../store';
import { questionnaireSpaceName } from './questionnaireReducer';

export const selectQuestionnaireLockConfirm = (state: RootState) => get(state, [questionnaireSpaceName, 'lockConfirmObj']);
